import React from "react";
import {useTranslation} from "react-i18next";
import Slider from "react-slick";

const Testimonials = ({ classicHeader, darkTheme }) => {
  const {t} = useTranslation();
  const reviews = [
    {
      name: "Jorge Luna - DevOps",
      position: "Chihuahua, México",
      src: "images/testimonial/jorge.png",
      desc: t('coworkers.speciallity.devops'),
      rating: 5,
    },
    {
      name: "Alfredo Anchondo - Full Stack Developer",
      position: "Chihuahua, México",
      src: "images/testimonial/alfredo.png",
      desc: t('coworkers.speciallity.fullstack'),
      rating: 5,
    },
    {
      name: "Joel Melendez - Ruby on Rails Developer",
      position: "Chihuahua, México",
      src: "images/testimonial/chino.png",
      desc: t('coworkers.speciallity.ruby_on_rails'),
      rating: 5,
    },
    {
      name: "Osiel Bonilla - Mobile Developer",
      position: "Chihuahua, México",
      src: "images/testimonial/osiel.png",
      desc: t('coworkers.speciallity.mobile'),
      rating: 5,
    },
    {
      name: "Adrian Vacc - Graphic Designer",
      position: "CDMX, México",
      src: "images/testimonial/adrian.png",
      desc: t('coworkers.speciallity.ruby_on_rails'),
      rating: 5,
    },
    {
      name: "Joel Bolaños - .Net Developer",
      position: "Veracruz, México",
      src: "images/testimonial/joel.png",
      desc: t('coworkers.speciallity.dot_net'),
      rating: 5,
    },
    {
      name: "Sergio Gil - IT Specialist",
      position: "CDMX, México",
      src: "images/testimonial/sergio.png",
      desc: t('coworkers.speciallity.it_specialist'),
      rating: 5,
    },
    {
      name: "Nitzia Ruiz - Marketing Specialist",
      position: "CDMX, México",
      src: "images/testimonial/nitzia.png",
      desc: t('coworkers.speciallity.marketing_specialist'),
      rating: 5,
    },
    {
      name: "Jonathan Martinez - Operations Specialist",
      position: "CDMX, México",
      src: "images/testimonial/jhony.png",
      desc: t('coworkers.speciallity.operations_specialist'),
      rating: 5,
    },
    {
      name: "Gabriela Juarez - CS Specialist",
      position: "CDMX, México",
      src: "images/testimonial/gaby.png",
      desc: t('coworkers.speciallity.customer_service_specialist'),
      rating: 5,
    }
  ];

  var settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
    ],
  };
  return (
    <section
      id="testimonial"
      className={"section " + (darkTheme ? "bg-dark-1" : "")}
    >
      <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
        {/* Heading */}
        <div className="position-relative d-flex text-center mb-5">
          <h2
            className={
              "text-24  text-uppercase fw-600 w-100 mb-0 " +
              (darkTheme ? "text-muted opacity-1" : "text-light opacity-4")
            }
          >
            {t('coworkers.title1')}
          </h2>
          <p
            className={
              "text-9 text-dark fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
              (darkTheme ? "text-white" : "text-dark")
            }
          >
            {" "}
            {t('coworkers.title2')}
            <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
          </p>
        </div>
        {/* Heading end*/}

        <Slider {...settings}>
          {reviews.length > 0 &&
            reviews.map((value, index) => (
              <div className="item" key={index}>
                <div
                  className={
                    " rounded p-5 " + (darkTheme ? "bg-dark" : "bg-light")
                  }
                >
                  <div className="d-flex align-items-center mt-auto mb-4">
                    <img
                      style={{ maxWidth: "70px", maxHeight: "70px" }}
                      className="img-fluid rounded-circle border d-inline-block w-auto"
                      src={value.src}
                      alt={value.name}
                      width="70"
                      height="70"
                      loading="lazy"
                    />
                    <p className="ms-3 mb-0">
                      <strong
                        className={
                          "d-block fw-600 " +
                          (darkTheme ? "text-white" : "text-dark")
                        }
                      >
                        {value.name}
                      </strong>
                      <span className="text-muted fw-500">
                        {" "}
                        {value.position}{" "}
                      </span>
                    </p>
                  </div>
                  <p
                    className={
                      " fw-500 mb-4 " + (darkTheme ? "text-white" : "text-dark")
                    }
                  >
                    {value.desc}
                  </p>
                  <span className="text-2">
                    {[...Array(value.rating)].map((value, i) => (
                      <i className="fas fa-star text-warning" key={i} />
                    ))}
                  </span>
                </div>
              </div>
            ))}
        </Slider>
      </div>
    </section>
  );
};

export default Testimonials;
